import Inputmask from 'inputmask';

export function applyDateMask() {
  var inputElements = document.querySelectorAll('.date-mask');

  inputElements.forEach(function(inputElement) {
    Inputmask({ mask: '99/99/9999' }).mask(inputElement);
  });
}
